export default __webpack_public_path__ + "static/media/Group 1107.aa663723.svg";